/** Apollo query names that power host studio lists (services page, calendar, hasStudios, profile). */
export const USER_STUDIOS_REFETCH_QUERIES = [
  'StudiosForServiceSelection',
  'StudiosForUserProfile',
  'HasStudios',
  'ListStudios',
];

export const refetchUserStudios = (client) =>
  client.refetchQueries({
    include: USER_STUDIOS_REFETCH_QUERIES,
  });
